<h2 class="font-heading-4 ms-small-b ms-xxlarge-t">
  {{ 'multiCity.flightSelection.fareFamilyTitle' | finLocalization }}
</h2>
<fcom-notification class="ms-small-b" data-testid="multi-city-fare-family-notification">
  {{ 'multiCity.flightSelection.fareFamilyNotification' | finLocalization }}
</fcom-notification>

<fin-fare-family-list
  [fareFamilies$]="fareFamilies$"
  [currencyCode]="currency$ | async"
  [showKoreaNotification]="showKoreaNotification$ | async"
  [isShortHaul$]="false | finToObservable"
  [isLongHaulLegAndAy$]="false | finToObservable"
  [roundedTop]="true"
  [allowAutoExpand]="true"
  [showUpsellCard]="true"
  (selectFareFamily)="selectFareFamily($event)"
  (openCabinClassModal)="openCabinClassModal($event)"
></fin-fare-family-list>

<fin-cabin-class-modal
  *ngIf="(isAllShortHaul$ | async) === false"
  [cabinClasses$]="availableCabins$"
></fin-cabin-class-modal>

<fin-multi-city-survey
  [alwaysRender]="true"
  class="block mr-small-b"
  [class.mr-xsmall-t]="isAllShortHaul$ | async"
></fin-multi-city-survey>

<fcom-cta-button
  data-testid="booking-multi-city-fare-family-continue-cta-button"
  [title]="'actions.next' | finLocalization"
  [visible]="!!(selectedFareFamily$ | async)"
  [position]="ButtonPosition.GRID_FULL"
  (buttonClicked)="continueWithSelection()"
>
  <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
  <span data-testid="cta-button-price" class="font-body-1 bold-type">{{
    { amount: (selectedFareFamily$ | async)?.totalPrice, currencyCode: currency$ | async } | finPrice
  }}</span>
</fcom-cta-button>
